import * as types from '../actions';

export default function setSegID(segID) {
  return {
    type: types.VIEWER_SET_SEG_ID,
    segID,
  };
}
